import React from 'react'

export default function PrivacyPolicy() {
  return (
    <>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Privacy Policy</title>
  <style
    dangerouslySetInnerHTML={{
      __html:
        "\n    .container{\n    font-family: sans-serif !important;\n    }\n  "
    }}
  />
  <section>
    <div className="container" style={{ maxWidth: 1300, margin: "0 auto" }}>
      <h2>Privacy Policy</h2>
      <p>
        The terms “We” / “Us” / “Our”/”Company” individually and collectively
        refer to Cephlon Technology LLP.and the terms “You” /”Your” / “Yourself”
        refer to the users. This Privacy Policy is an electronic record in the
        form of an electronic contract formed under the information Technology
        Act, 2000 and the rules made thereunder and the amended provisions
        pertaining to electronic documents / records in various statutes as
        amended by the information Technology Act, 2000. This Privacy Policy
        does not require any physical, electronic or digital signature.{" "}
      </p>
      <p>
        This Privacy Policy is a legally binding document between you and
        Cephlon Technology LLP (both terms defined below). The terms of this
        Privacy Policy will be effective upon your acceptance of the same
        (directly or indirectly in electronic form, by clicking on the I accept
        tab or by use of the website or by other means) and will govern the
        relationship between you and Cephlon Technology LLP for your use of the
        website “Website” (defined below).
      </p>
      <p>
        {" "}
        This document is published and shall be construed in accordance with the
        provisions of the Information Technology (reasonable security practices
        and procedures and sensitive personal data of information) rules, 2011
        under Information Technology Act, 2000; that require publishing of the
        Privacy Policy for collection, use, storage and transfer of sensitive
        personal data or information.{" "}
      </p>
      <p>
        Please read this Privacy Policy carefully by using the Website, you
        indicate that you understand, agree and consent to this Privacy Policy.
        If you do not agree with the terms of this Privacy Policy, please do not
        use this Website.
      </p>
      <p>
        By providing us your Information or by making use of the facilities
        provided by the Website, You hereby consent to the collection, storage,
        processing and transfer of any or all of Your Personal Information and
        Non-Personal Information by us as specified under this Privacy Policy.
        You further agree that such collection, use, storage and transfer of
        Your Information shall not cause any loss or wrongful gain to you or any
        other person.
      </p>
      <ul style={{ paddingLeft: 10 }}>
        <li style={{ marginBottom: 10 }}>USER INFORMATION</li>
        <li style={{ marginBottom: 10 }}>
          INFORMATION COLLECTED THROUGH OUR PRODUCTS
        </li>
        <li style={{ marginBottom: 10 }}>
          HOW THE PERSONAL INFORMATION IS USED
        </li>
        <li style={{ marginBottom: 10 }}>COOKIES</li>
        <li style={{ marginBottom: 10 }}>LINKS TO THE OTHER SITES</li>
        <li style={{ marginBottom: 10 }}>INFORMATION SHARING</li>
        <li style={{ marginBottom: 10 }}>INFORMATION SECURITY</li>
        <li style={{ marginBottom: 10 }}>GRIEVANCE REDRESSAL</li>
      </ul>
      <h2>User Information</h2>
      <p>
        To avail certain services on our Websites, users are required to provide
        certain information for the registration process namely: – a) your name,
        b) email address, c) gender, d) age, e) PIN code f)Phone Number. The
        Information as supplied by the users enables us to improve our
        Website/Application and provide you the most user-friendly experience.
      </p>
      <p>
        To provide users with certain features and experiences our smartphone
        APP will teperarily collect location data. Such location based data is
        not stored or shared with any third party{" "}
      </p>
      <p>
        All required information is service dependent and we may use the above
        said user information to, maintain, protect, and improve its services
        (including advertising services) and for developing new services.
      </p>
      <p>
        Such information will not be considered as sensitive if it is freely
        available and accessible in the public domain or is furnished under the
        Right to Information Act, 2005 or any other law for the time being in
        force.
      </p>
      <h2>Information Collected through our Products</h2>
      <p>
        The collection of some data, including personal information, may be
        necessary to the functionality of your Cephlon automation and networking
        systems. When you install our products and systems, we receive
        information that you or your authorized installer inputs into your our
        system, which may include:
      </p>
      <p>The model and serial numbers of the Cephlon products installed;</p>
      <p>The version and type of Application installed;</p>
      <p>The names of the rooms where you have connected devices;</p>
      <p>Your zip code or time zone; and</p>
      <p>Other information about your configuration.</p>
      <p>
        Some of our products also allow us to automatically receive data related
        to the functionality and use of the system, such as:
      </p>
      <p>
        The time, frequency, and type of use of the various components your
        system;
      </p>
      <p>
        History of your device settings including any adjustments you make, data
        from any sensors built into the Cephlon system or the products you
        integrate into the system;
      </p>
      <p>
        This project-specific data may be stored along with any account
        information you provide when you set up an account with Cephlon
        including your email and other contact information. We use this
        information to help us customize our communications to you, troubleshoot
        problems with your system or account, and to improve the functionality
        of our products. More importantly, we use this information to provide
        the core functionality of your automation system.
      </p>
      <h2>How The Personal Information Is Used</h2>
      <p>
        Cephlon may collect and use your information for the following purposes:
      </p>
      <p>To provide you the products and services you purchase;</p>
      <p>
        To enable the functionality of your automation system and to personalize
        and customize your home automation experience;
      </p>
      <p>To provide you the content on our Sites;</p>
      <p>
        To improve customer service and respond to requests. Information you
        provide helps us respond to your service requests and support needs more
        efficiently and enables us to contact you in response to your requests
        for product information and support;
      </p>
      <p>
        To register your system. Note that we often first receive our end users’
        information through the registration of our systems which is often
        facilitated by the end user’s authorized installation contractor;
      </p>
      <p>To improve our products and services;</p>
      <p>
        To process orders, warranty claims and payments from our users, dealers
        ,and distributors;
      </p>
      <p>To run promotions, contests, surveys, or similar features;</p>
      <p>
        To conduct market research about our users to improve our marketing
        campaigns, content on our Sites
      </p>
      <p>
        To allow our technical support personnel or your registered independent
        dealer to remotely troubleshoot problems with your network or other
        control systems;
      </p>
      <p>
        To contact you by telephone to discuss your account or respond to
        requests and questions;
      </p>
      <p>
        To send you periodic emails. We may use email addresses provided to us
        to send information and updates pertaining to accounts, purchases, or
        products. It may also be used to respond to inquiries and requests. If
        you opt-in to our mailing lists, you will also receive emails that may
        include company news, newsletters, surveys, updates, related product or
        service information, and the like; and For other purposes based on your
        consent.
      </p>
      <p>
        We may also use information in the aggregate to understand how our
        visitors and customers as a group use the resources provided on our
        Sites/Applications and improve our products. We may also share
        aggregated, non-personally identifiable information publicly and with
        our partners.
      </p>
      <p>
        We may also use the information through our AI automated system (may be
        supervised learning but without personally identifiable information) to
        provide a personalized and customized automation experience on the
        Website and Application. For example :- Recommending a particular
        pre-defined scene to be created, notifying when your Applicance is left
        turned on for longer than average time or any other preventive
        maintenance features.
      </p>
      <h2>Cookies</h2>
      <p>
        To improve the responsiveness of the sites for our users, we may use
        “cookies”, or similar electronic tools to collect information to assign
        each visitor a unique, random number as a User Identification (User ID)
        to understand the user’s individual interests using the Identified
        Computer. Unless you voluntarily identify yourself (through
        registration, for example), we will have no way of knowing who you are,
        even if we assign a cookie to your computer. A cookie cannot read data
        off your hard drive. Our advertisers may also assign their own cookies
        to your browser (if you click on their ads), a process that we do not
        control.
      </p>
      <p>
        Our web servers automatically collect limited information about your
        computer’s connection to the Internet, including your IP address, when
        you visit our site. (Your IP address is a number that lets computers
        attached to the Internet know where to send you data — such as the web
        pages you view.) Your IP address does not identify you personally. We
        use this information to deliver our web pages to you upon request, to
        tailor our site to the interests of our users, to measure traffic within
        our site and let advertisers know the geographic locations from where
        our visitors come.
      </p>
      <h2>Links to the other sites</h2>
      <p>
        Our policy discloses the privacy practices for our own web site only.
        Our site provides links to other websites also that are beyond our
        control. We shall in no way be responsible for your use of such sites.
      </p>
      <h2>Information Sharing</h2>
      <p>
        We shares the sensitive personal information to any third party without
        obtaining the prior consent of the user in the following limited
        circumstances:
      </p>
      <p>
        <strong>(a)</strong> When it is requested or required by law or by any
        court or governmental agency or authority to disclose, for the purpose
        of verification of identity, or for the prevention, detection,
        investigation including cyber incidents, or for prosecution and
        punishment of offences. These disclosures are made in good faith and
        belief that such disclosure is reasonably necessary for enforcing these
        Terms; for complying with the applicable laws and regulations.
      </p>
      <p>
        <strong>(b)</strong>Your personal information may be shared with our
        agents, subsidiaries, and affiliates who are obligated to safeguard it
        in accordance with this Privacy Policy. There are also times when
        Cephlon makes certain personal information about you available to
        companies that help support our business or that provide products and
        services to you on our behalf. These companies may use your personal
        information only to assist us accomplish one or more of the purposes for
        which we collected the information as set forth herein. For example,
        these partners may help us process information or credit card payments,
        sell and deliver products to you, fulfill orders, manage or host
        customer data, provide customer service, assess your interest in our
        products and services, or conduct customer research or satisfaction
        surveys
      </p>
      <h2>Information Security</h2>
      <p>
        We take appropriate security measures to protect against unauthorized
        access to or unauthorized alteration, disclosure or destruction of data.
        These include internal reviews of our data collection, storage and
        processing practices and security measures, including appropriate
        encryption and physical security measures to guard against unauthorized
        access to systems where we store personal data.
      </p>
      <p>
        All information gathered on our Website/Application is securely stored
        within our controlled database. The database is stored on servers
        secured behind a firewall; access to the servers is password-protected
        and is strictly limited. However, as effective as our security measures
        are, no security system is impenetrable. We cannot guarantee the
        security of our database, nor can we guarantee that information you
        supply will not be intercepted while being transmitted to us over the
        Internet.
      </p>
      <p>
        However the internet is an ever evolving medium. We may change our
        Privacy Policy from time to time to incorporate necessary future
        changes. Of course, our use of any information we gather will always be
        consistent with the policy under which the information was collected,
        regardless of what the new policy may be.
      </p>
      <h2>Grievance Redressal</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or your
        information, please email our Data Protection Officer at
        saumya@cephlon.tech
      </p>
    </div>
  </section>
</>

  )
}
